<a class="banner-content" *ngIf="(hideGamingCrossSellByArc$ | async) === false" [attr.target]="model.link?.target" (click)="onJackpotBannerClick()">
    <img class="banner-background-image" fill *ngIf="model.background" [ngSrc]="model.background" [priority]="listIndex === 0" />
    <div class="banner-info">
        <div class="banner-title">{{ model.title }}</div>
        <div class="banner-subtitle">{{ model.subtitle }}</div>
        <div class="banner-ticker">
            <div
                *ngFor="let character of characters; trackBy: trackByFn"
                [ngClass]="{ 'banner-tick-currency': character.isCurrency, 'banner-tick-separator': character.isSeparator }">
                <div *ngIf="character.isCurrency">{{ character.currency }}</div>
                <div *ngIf="character.isSeparator">{{ character.separator }}</div>
                <ms-banner-tick *ngIf="character.isDigit" [model]="character.digit" />
            </div>
        </div>
    </div>
    <div class="banner-image"><img width="86" *ngIf="model.icon" [ngSrc]="model.icon" /></div>
</a>
